import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EventService } from './event.service';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [EventService]
})
export class EventModule {}
